import api from './axiosInstance';

export const taskTypeApi = {
  list: () => api.get('/task-types'),
  create: (data) => api.post('/task-types', data),
  update: (id, data) => api.put(`/task-types/${id}`, data),
  remove: (id) => api.delete(`/task-types/${id}`),
  reorder: (orderedIds) => api.put('/task-types/reorder', {orderedIds}),
};
